module.exports = __webpack_public_path__ + "static/media/comment-smile.edde6831.svg";